export default "__VITE_ASSET__C90rFh7n__"